// extracted by mini-css-extract-plugin
export default {"root":"IconShortListAdded_root__m3FQ2","tick":"IconShortListAdded_tick__fgOJc"};